var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4390_13267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "unlock-alt",
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4390_13267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.19 10C16.88 10 17.72 10 18.36 10.32C18.92 10.61 19.38 11.07 19.67 11.63C20 12.27 20 13.11 20 14.79L20 16.2C20 17.88 20 18.72 19.67 19.36C19.38 19.92 18.92 20.38 18.36 20.67C17.72 21 16.88 21 15.19 21L8.8 21C7.11 21 6.27 21 5.63 20.67C5.07 20.38 4.61 19.92 4.32 19.36C4 18.72 4 17.88 4 16.2L4 14.79C4 13.11 4 12.27 4.32 11.63C4.61 11.07 5.07 10.61 5.63 10.32C5.99 10.14 6.41 10.06 7 10.02C7.47 10 8.05 10 8.8 10L15.19 10ZM16.58 6C15.81 4.23 14.05 3 12 3C9.23 3 7 5.23 7 8L7 10.02M12 14.5L12 16.5",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockAlt);
export default __webpack_public_path__ + "static/media/unlock-alt.20faf96e7cbd533c44ad1a7bc997c62c.svg";
export { ForwardRef as ReactComponent };